import React from 'react';
import {Flipped, Flipper} from 'react-flip-toolkit';
import {useVotingResults} from '../useVotingResults';
import Option from './Option/Option';
import stylesheet from './OptionsKey.module.scss';

const OptionsKey = props => {
    const {question, results} = props,
        options = props.options || question.options,
        [votes, sum] = useVotingResults(results);

    return (
        <Flipper className={stylesheet.OptionsKey} flipKey={options.map(option => option.id).join()}>
            {options.map(option => (
                <Flipped key={option.id} flipId={option.id}>
                    {flippedProps => <Option key={option.id} option={option} percentage={sum ? (votes[option.id] / sum) * 100 : 0} flippedProps={flippedProps} />}
                </Flipped>
            ))}
        </Flipper>
    );
};

export default OptionsKey;
